import { createContext, useContext } from 'react';

import type { ContentImage } from '@/graphql/generated';

export type TransType = {
  label: Record<string, string>;
  image: Record<string, Omit<ContentImage, '__typename'>>;
};

export type TranslationContext = {
  content: TransType;
  loading: boolean;
  error?: Error;
};

export const TranslationsCtx = createContext<TranslationContext>({
  content: {
    label: {},
    image: {},
  },
  loading: true,
});

export const useTranslations = () => {
  const {
    content: { label, image },
    loading,
    error,
  } = useContext(TranslationsCtx);
  // TODO: change the return data structure as an object
  return [label, image, loading, error] as const;
};
